import React from "react";
import DonutChart from "../../elements/donut-chart/DonutChart";
import classes from "./PointIndicator.module.scss";

/**
 * ポイントインジケーターモジュールのプロパティ
 */
type PointIndicatorProps = {
  /** 目標金額 */
  total?: number;
  /** 現在の到達金額 */
  current?: number;
  /** 達成時のインセンティブ */
  incentive?: number;
};

/**
 * ポイントインジケーターモジュール
 * @param props ポイントインジケーターモジュールのプロパティ
 */
const PointIndicator: React.FC<PointIndicatorProps> = (props) => {
  if (!props.total || props.current === undefined || !props.incentive) {
    return null;
  }

  return (
    <div className={classes.indicatorBody}>
      <DonutChart progress={props.current / props.total}></DonutChart>
      <div className={classes.content}>
        {props.total > props.current ? (
          <div className={classes.incompletedAnimation}>
            <div>
              <span className={`${classes.number} ${classes.currentCharge}`}>
                {props.current.toLocaleString()}
              </span>
              円 /
              <span className={classes.number}>
                {props.total.toLocaleString()}
              </span>
              円
            </div>
            <hr className={classes.sepLine}></hr>
            <div>
              <div className="small">達成まで あと</div>
              <div>
                <span className={`${classes.number} ${classes.remaining}`}>
                  {(props.total - props.current).toLocaleString()}
                </span>
                円
              </div>
            </div>
          </div>
        ) : (
          <div className={classes.completedAnimation}>
            <div className={classes.completeMessage}>Congratulations!!</div>
            {Number.isFinite(props.incentive) ? (
              <>
                <div className={classes.incentive}>
                  <span className={classes.number}>
                    {props.incentive.toLocaleString()}
                  </span>
                  pt
                </div>
                <div>プレゼント！</div>
              </>
            ) : (
              <div className={`${classes.incentive}`}>
                <span className={classes.label}>{props.incentive}</span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PointIndicator;
